export default __webpack_public_path__ + "static/media/icon-youtube.cad14335.svg";